import React from 'react';
import { Server } from '../../server/server';
import AlertModal from './AlertModal';
import MessageModal from './MessageModal';
import { Navigate } from 'react-router-dom';
import UsersModal from './UsersModal';
import UsersPanel from '../elements/UsersPanel';
import Modal from '../elements/Modal';

interface GroupChatModalProps {
  title: string;
  id?: string;
  onBack?: Function;
  onClose: Function;
}

interface GroupChatModalState {
  name: string;
  members: string[];
  showFriends: boolean;
  friends: string[];
  alert: string;
  message: string;
  navigate: string;
  loading: boolean;
}

class GroupChatModal extends React.Component<GroupChatModalProps, GroupChatModalState> {
  constructor(props:GroupChatModalProps) {
    super(props);
    this.state = {
      name: '',
      members: [],
      showFriends: false,
      friends: [],
      alert: '',
      message: '',
      navigate: '',
      loading: false
    }
  }

  componentDidMount(): void {
    if(this.props.id) 
      this.loadGroup();
  }

  async loadGroup() {
    let chat = Server.user.getChat(this.props.id);
    if(!chat || chat.type != 'group') return;

    this.setState({name: chat.name});

    let members = await Server.chat.getMembersCache(this.props.id);

    if(!members) {
      this.setState({loading: true});
      let response = await Server.chat.getChatMembers(this.props.id);
      if(response.success) {
        members = response.members;
        await Server.chat.setMembersCache(this.props.id, members);
      }
    }

    await Server.public.loadProfiles(members);

    this.setState({members, loading: false});
  }

  onMemberClick(id:string) {
  }

  onAddFriend() {
    let userFriends = Server.user.getFriendsFromCache();

    if(userFriends.length == 0) {
      this.setState({alert: 'You don\'t yet have any friends to add to the chat.'});
      return;
    }

    let filteredFriends = userFriends.filter((f:any)=>this.state.members.indexOf(f.id) == -1);
    let friends = filteredFriends.map((f:any)=>f.id);

    if(friends.length == 0) {
      this.setState({alert: 'All of your friends are already members in this chat.'});
      return;
    }

    this.setState({showFriends: true, friends});
  }

  onFriendsClose() {
    this.setState({showFriends: false});
    this.props.onClose();
  }

  onFriendClick(id:string) {
    let members = [...this.state.members];
    members.push(id);
    this.setState({showFriends: false, members});
  }

  onCreateGroup() {
    if(this.state.name == '') {
      this.setState({alert: 'Please name the group.'});
      return;
    }

    if(this.state.members.length == 0) {
      this.setState({alert: 'Please add friends to the group.'});
      return;
    }

    this.setState({message: 'Starting chat...'});

    setTimeout(async () => {
      let response = await Server.chat.startChat({
        type: 'group',
        name: this.state.name,
        members: this.state.members
      });

      this.setState({message: ''});

      if(response.success) {
        Server.user.startChat({id: response.id, type: 'group', name: this.state.name});
        Server.network.sendCommand('start-chat', {chat: response.id, type: 'group', name: this.state.name, members: this.state.members});
        this.setState({navigate: '/chat/group/' + response.id});
      }
      else
        this.setState({alert: response.message})
    }, 500);
  }
  
  onSaveGroup() {
    if(this.state.name == '') {
      this.setState({alert: 'Please name the group.'});
      return;
    }

    if(this.state.members.length == 0) {
      this.setState({alert: 'Please add friends to the group.'});
      return;
    }

    this.setState({message: 'Saving settings...'});

    setTimeout(async () => {
      let existingMembers = await Server.chat.getMembersCache(this.props.id);
      let newMembers = this.state.members.filter((member: string) => !existingMembers.includes(member));

      let response = await Server.chat.updateChat({
        id: this.props.id,
        type: 'group',
        name: this.state.name,
        members: this.state.members
      });

      for(let i = 0; i < newMembers.length; i++) 
        Server.network.sendCommand('start-chat', {chat: this.props.id, type: 'group', name: this.state.name, members: this.state.members});

      this.setState({message: ''});

      if(response.success) {
        let chat = Server.user.getChat(this.props.id);
        chat.name = this.state.name;
        this.props.onClose();
      }
      else
        this.setState({alert: response.message})
    }, 500);
  }

  render() {
    if(this.state.navigate) 
      return <Navigate to={this.state.navigate} />

    if(this.state.showFriends) {
      return (
        <UsersModal 
          title="Select Friend"
          users={this.state.friends}
          onBack={()=>this.setState({showFriends: false})}
          onClick={(id:string)=>this.onFriendClick(id)}
          onClose={()=>this.onFriendsClose()}
        />
      )
    }

    return (
      <Modal title={this.props.title} onClose={()=>this.props.onClose()} showBack={this.props.onBack != null} onBack={()=>this.props.onBack()}>
        <div className="site-page-column" style={{textAlign: 'left'}}>
          <div className="site-page-column" style={{rowGap: '5px'}}>
            <div className="site-page-subtext">Name:</div>
            <input value={this.state.name} onChange={(e:any)=>this.setState({name: e.currentTarget.value})} />
          </div>
          <div className="site-page-column" style={{rowGap: '5px'}}>
            <div className="site-page-subtext">Members:</div>
            <UsersPanel
              height="200px"
              users={this.state.members}
              onClick={(id:string)=>this.onMemberClick(id)}
            />
          </div>
          <div className="site-page-row" style={{justifyContent: 'space-between'}}>
            <button onClick={()=>this.onAddFriend()}>Add Friend</button>
            {this.props.id ? 
              <button onClick={()=>this.onSaveGroup()}>Save</button> :
              <button onClick={()=>this.onCreateGroup()}>Create</button> 
            }
          </div>
        </div>
        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </Modal>
    )
  }
}

export default GroupChatModal;